'use client';
import { useRef } from 'react';

import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { useImageCarousel } from '@shared-components/ImageCarousel/Hooks/UseImageCarousel';
import { ImageCarousel } from '@shared-components/ImageCarousel/ImageCarousel';
import type { imageCarouselMessages } from '@shared-components/ImageCarousel/ImageCarousel.messages';

export const ImageCarouselWrapper = ({
  images,
  strings,
  locale,
}: {
  images: VehicleImage[];
  strings: Record<keyof typeof imageCarouselMessages, string>;
  locale: Locale;
}) => {
  const carouselRef = useRef<HTMLDivElement>(null);

  const { currentIndex, dragStart, dragging, dragEnd, moveTo, fromIndex, toIndex } =
    useImageCarousel(carouselRef);

  const carouselProps = {
    currentIndex,
    dragStart,
    dragging,
    dragEnd,
    moveTo,
    fromIndex,
    toIndex,
    carouselRef,
  };

  return (
    <ImageCarousel
      carouselProps={carouselProps}
      images={images}
      index={0}
      size="review"
      strings={strings}
      locale={locale}
    />
  );
};
